module.exports = __webpack_public_path__ + "media/images/team/MagdaRoberto-9a45f06b2a95d3c0aacd1cba2932d09d.png";